import { withInstall } from '@map-sdk/utils'

import baseMapComponent from './src/index.vue'

export const BaseMapComponent = withInstall(baseMapComponent)
export default BaseMapComponent

// export * from './src/alert' // props
export type { MapInstance, ShowLayerType } from './src/instance'
